import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { API_URL } from "../services/api";

export default function NubepalabrasPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const imageUrl = `${API_URL.replace("/api", "")}/media/wordcloud_enfermedades.png?ts=${new Date().toISOString().slice(0,10)}`;

  return (
    <div className="max-w-5xl mx-auto p-6 mt-5">
      <div className="flex items-center justify-between flex-wrap gap-4 mb-6">
        <h2 className="text-2xl font-bold text-[#247BA8] flex-1">

        </h2>

        <button
          onClick={() => navigate("/recursos")}
          className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#247BA8] text-white shadow-sm transition hover:bg-[#1B6388] hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#247BA8]/30 focus-visible:ring-offset-2"
        >
          <ArrowLeft size={20} />
        </button>
      </div>

      <div className="rounded-lg overflow-hidden shadow-lg border border-gray-300">
        <img
          src={imageUrl}
          alt={t("wordcloud.alt", "Visualización de nube de palabras")}
          className="w-full h-auto object-contain"
        />
      </div>
    </div>
  );
}
